/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateBatchJob = /* GraphQL */ `subscription OnCreateBatchJob($filter: ModelSubscriptionBatchJobFilterInput) {
  onCreateBatchJob(filter: $filter) {
    createdAt
    expiredAt
    id
    jobName
    remarks
    status
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBatchJobSubscriptionVariables,
  APITypes.OnCreateBatchJobSubscription
>;
export const onCreateDummy = /* GraphQL */ `subscription OnCreateDummy($filter: ModelSubscriptionDummyFilterInput) {
  onCreateDummy(filter: $filter) {
    createdAt
    id
    kintoneAppScope
    kintoneDataKind
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDummySubscriptionVariables,
  APITypes.OnCreateDummySubscription
>;
export const onCreateScraping = /* GraphQL */ `subscription OnCreateScraping($filter: ModelSubscriptionScrapingFilterInput) {
  onCreateScraping(filter: $filter) {
    baseUrl
    createdAt
    endedAt
    input
    operation
    output
    prefName
    remarks
    resultKey
    sortKey
    startedAt
    status
    totalCount
    updated {
      blocked
      expired
      newRecord
      onSite
      requiresAuth
      return
      returnAndUpdatePrice
      scrapingFailed
      updateFailed
      updatePrice
      __typename
    }
    updatedAt
    updating {
      blocked
      expired
      newRecord
      onSite
      requiresAuth
      return
      returnAndUpdatePrice
      scrapingFailed
      updateFailed
      updatePrice
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateScrapingSubscriptionVariables,
  APITypes.OnCreateScrapingSubscription
>;
export const onDeleteBatchJob = /* GraphQL */ `subscription OnDeleteBatchJob($filter: ModelSubscriptionBatchJobFilterInput) {
  onDeleteBatchJob(filter: $filter) {
    createdAt
    expiredAt
    id
    jobName
    remarks
    status
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBatchJobSubscriptionVariables,
  APITypes.OnDeleteBatchJobSubscription
>;
export const onDeleteDummy = /* GraphQL */ `subscription OnDeleteDummy($filter: ModelSubscriptionDummyFilterInput) {
  onDeleteDummy(filter: $filter) {
    createdAt
    id
    kintoneAppScope
    kintoneDataKind
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDummySubscriptionVariables,
  APITypes.OnDeleteDummySubscription
>;
export const onNotifyEstateC = /* GraphQL */ `subscription OnNotifyEstateC {
  onNotifyEstateC {
    address
    appearanceImgs
    area
    balconyArea
    bcr
    bldConditionType
    buildingCompany
    buildingFloors
    cadastralMapPdf
    carsInParkingN
    city
    cityPlanningType
    cleaningMonth
    clearingType
    collectedAt
    companyAddress
    companyBranchId
    companyFax
    companyGuaranter
    companyId
    companyLicense
    companyName
    companyRecNo
    companyTel
    companyUrl
    completionMonth
    completionMonthS
    completionSchMonth
    condominiumId
    condominiumName
    condominiumRecNo
    confirmed
    createdAt
    currentStatus
    currentStatusB
    currentStatusFree
    currentStatusG
    deletedOnSumora
    drivewayPay
    eSchool
    estatePrice
    estateType
    estateUrl
    exactLocation
    floor
    floorAreaRatio
    floorStructure
    fullAddress
    gas
    gasPdf
    groundPdf
    groundType
    groundTypeFree
    id
    infoName
    isLot
    jSchool
    landAreaType
    landRights
    latitude
    layout
    layoutImgs
    license
    location
    longitude
    managementFee
    managementType
    manager
    mapImg
    media
    mediationKind
    name
    nearlyLocation
    notFoundAt
    otherCost
    owner
    parking
    parkingFee
    parkingHeight
    parkingMechOrPlane
    parkingTakeOver
    parkingTakeOverFree
    pet
    prefecture
    priceHistory {
      price
      pricedAt
      __typename
    }
    pricedAt
    purposeB
    purposeSummaryB
    recNo
    remarks
    repairCost
    roadDirection
    roadType
    roadWidth
    room
    searchInfo
    seller
    sewer
    sewerPdf
    sold
    squareArea
    status
    store
    structure
    structureFree
    subCompany2Address
    subCompany2Fax
    subCompany2Guaranter
    subCompany2Id
    subCompany2License
    subCompany2Name
    subCompany2Tel
    subCompany2Url
    subCompanyAddress
    subCompanyFax
    subCompanyGuaranter
    subCompanyId
    subCompanyLicense
    subCompanyName
    subCompanyRecNo
    subCompanyTel
    subCompanyUrl
    tileOnZoom12
    tileOnZoom14
    tileOnZoom16
    totalArea
    totalHouses
    traffic
    tsuboArea
    unitPrice
    unsettledLocation
    updatedAt
    url
    useDistrict
    water
    waterPdf
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnNotifyEstateCSubscriptionVariables,
  APITypes.OnNotifyEstateCSubscription
>;
export const onUpdateBatchJob = /* GraphQL */ `subscription OnUpdateBatchJob($filter: ModelSubscriptionBatchJobFilterInput) {
  onUpdateBatchJob(filter: $filter) {
    createdAt
    expiredAt
    id
    jobName
    remarks
    status
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBatchJobSubscriptionVariables,
  APITypes.OnUpdateBatchJobSubscription
>;
export const onUpdateDummy = /* GraphQL */ `subscription OnUpdateDummy($filter: ModelSubscriptionDummyFilterInput) {
  onUpdateDummy(filter: $filter) {
    createdAt
    id
    kintoneAppScope
    kintoneDataKind
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDummySubscriptionVariables,
  APITypes.OnUpdateDummySubscription
>;
export const onUpdateScraping = /* GraphQL */ `subscription OnUpdateScraping($filter: ModelSubscriptionScrapingFilterInput) {
  onUpdateScraping(filter: $filter) {
    baseUrl
    createdAt
    endedAt
    input
    operation
    output
    prefName
    remarks
    resultKey
    sortKey
    startedAt
    status
    totalCount
    updated {
      blocked
      expired
      newRecord
      onSite
      requiresAuth
      return
      returnAndUpdatePrice
      scrapingFailed
      updateFailed
      updatePrice
      __typename
    }
    updatedAt
    updating {
      blocked
      expired
      newRecord
      onSite
      requiresAuth
      return
      returnAndUpdatePrice
      scrapingFailed
      updateFailed
      updatePrice
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateScrapingSubscriptionVariables,
  APITypes.OnUpdateScrapingSubscription
>;
